import styled, { css, keyframes } from "styled-components";
import { theme } from "../../../constants/StyledComponents";
import { NotificationTypeEnum } from "../Notification/Notification";

const slideBottom = keyframes`
  from {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
`;

const slideBottomOut = keyframes`
  from {
    transform: translate(-50%, 0);
    opacity: 1;
  }
  to {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
`;

const backgroundStyles = (type: NotificationTypeEnum) =>
  ({
    success: css`
      background-color: ${theme.colors.green_2};
    `,
    warning: css`
      background-color: ${theme.colors.yellow_3};
    `,
    error: css`
      background-color: ${theme.colors.red_2};
    `,
  })[type];

export const StyledToastBanner = styled.div<{
  $type: NotificationTypeEnum;
}>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: ${theme.variables.border_radius_1};
  ${({ $type }) => backgroundStyles($type)}
  box-sizing: border-box;
  min-height: 48px;
`;

export const StyledToastIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const StyledToastText = styled.div`
  color: ${theme.colors.black};
  font-family: ${theme.variables.font_family};
  font-size: ${theme.variables.fs_14};
  font-weight: ${theme.variables.fw_semiBold};
  line-height: 1.4;
`;

const TOAST_ANIMATION_DURATION_MS = 300;

export const StyledToastContainer = styled.div<{ $isExiting?: boolean }>`
  position: fixed;
  bottom: 24px;
  left: 50%;
  z-index: 9999;
  max-width: 90vw;
  animation: ${({ $isExiting }) => ($isExiting ? slideBottomOut : slideBottom)}
    0.3s ease-in-out forwards;
`;

export const TOAST_EXIT_ANIMATION_MS = TOAST_ANIMATION_DURATION_MS;
